(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerNode = this.header.querySelector('header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.revealThreshold = Number(this.dataset.revealThreshold || 600);
      if (Number.isNaN(this.revealThreshold)) {
        this.revealThreshold = 600;
      }
      this.headerBounds = {};
      this.hasPassedRevealThreshold = false;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerBottom = this.headerBounds.bottom || this.header.offsetHeight || 0;
      const headerTop = this.headerBounds.top || 0;
      const revealThreshold = Math.max(this.revealThreshold, headerBottom);
      const isScrollingDown = scrollTop > this.currentScrollTop;
      const isScrollingUp = scrollTop < this.currentScrollTop;

      if (scrollTop > revealThreshold) {
        this.hasPassedRevealThreshold = true;
      }

      if (scrollTop > window.innerHeight) {
        this.header.classList.add('scrolled-past-header');
        if (this.headerNode.getAttribute('fixed-mode') !== 'true') {
          this.headerNode.setAttribute('mode', 'black');
        }
      } else {
        this.header.classList.remove('scrolled-past-header');
        if (this.headerNode.getAttribute('fixed-mode') !== 'true') {
          this.headerNode.setAttribute('mode', 'white');
        }
      }

      if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        this.hasPassedRevealThreshold = false;
        this.reset();
      } else if (isScrollingDown) {
        this.header.classList.add('scrolled-past-header');
        if (scrollTop <= revealThreshold) {
          this.reset();
        } else {
          this.hide();
        }
      } else if (isScrollingUp) {
        if (!this.hasPassedRevealThreshold) {
          this.reset();
          this.currentScrollTop = scrollTop;
          return;
        }

        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scribe-product-main-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scribe-product-v2')) {
    customElements.define('scribe-product-v2', class ScribeProductV2 extends HTMLElement {
      connectedCallback() {
        this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
        this.optionInputs = Array.from(this.querySelectorAll('[data-option-input]'));
        this.variantInput = this.querySelector('[data-variant-id-input]');
        this.mainQuantity = this.querySelector('[data-main-quantity]');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.mainPrice = this.querySelector('[data-main-price]');
        this.orderTotal = this.querySelector('[data-order-total]');
        this.currency = this.dataset.currency || 'USD';
        this.locale = this.dataset.locale || 'en';
        this.initialVariantId = Number(this.dataset.currentVariantId || 0);
        this.basePlanValue = this.dataset.basePlanValue || 'Not Now';
        this.currentVariant = null;
        this.nav = this.querySelector('[data-product-nav]');
        this.navAnchor = this.querySelector('[data-nav-anchor]');
        this.plansDialog = this.querySelector('[data-plans-dialog]');
        this.plansContent = this.querySelector('[data-plans-content]');
        this.plansModalTrigger = null;
        this.countdownIntervals = [];
        this.handleFloatingNav = this.updateFloatingNav.bind(this);
        this.handlePlansDialogClose = () => {
          if (this.plansModalTrigger)
            this.plansModalTrigger.focus();

        };

        this.addEventListener('change', this.handleChange.bind(this));
        this.addEventListener('click', this.handleClick.bind(this));
        if (this.plansDialog)
          this.plansDialog.addEventListener('close', this.handlePlansDialogClose);

        window.addEventListener('scroll', this.handleFloatingNav, {passive: true});
        window.addEventListener('resize', this.handleFloatingNav);
        this.initializeCountdowns();
        this.initializeThumbnailImages();
        this.updateProduct();
        this.initializeGallery();
        this.updateFloatingNav();
      }

      disconnectedCallback() {
        if (this.plansDialog)
          this.plansDialog.removeEventListener('close', this.handlePlansDialogClose);

        window.removeEventListener('scroll', this.handleFloatingNav);
        window.removeEventListener('resize', this.handleFloatingNav);
        this.countdownIntervals.forEach((intervalId) => window.clearInterval(intervalId));
        this.countdownIntervals = [];
      }

      get selectedOptions() {
        const values = [];
        this.optionInputs.forEach((input) => {
          if (input.checked)
            values[Number(input.dataset.optionIndex)] = input.value;


        });
        return values;
      }

      findVariant(options) {
        if (!options.length || options.every((value) => value == null)) {
          return this.product.variants.find((variant) => variant.id === this.initialVariantId)
            || this.product.variants.find((variant) => variant.available)
            || this.product.variants[0];
        }

        return this.product.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(Number(cents || 0) / 100);
      }

      handleChange(event) {
        if (event.target.matches('[data-option-input]'))
          this.updateProduct();


        if (event.target.matches('[data-main-quantity], [data-accessory-input]')) {
          const card = event.target.closest('[data-accessory-card]');
          if (card)
            card.classList.toggle('is-selected', event.target.checked);


          this.updateTotals();
        }
      }

      handleClick(event) {
        const plansModalTrigger = event.target.closest('[data-open-plans-modal]');
        if (plansModalTrigger) {
          event.preventDefault();
          this.openPlansDialog(plansModalTrigger);
          return;
        }

        if (event.target.closest('[data-close-plans-modal]') || event.target === this.plansDialog) {
          if (this.plansDialog && this.plansDialog.open)
            this.plansDialog.close();

          return;
        }

        const mainQuantityButton = event.target.closest('[data-main-quantity-change]');
        if (mainQuantityButton) {
          this.changeNumberInput(this.mainQuantity, Number(mainQuantityButton.dataset.mainQuantityChange));
          return;
        }

        const accessoryQuantityButton = event.target.closest('[data-accessory-quantity-change]');
        if (accessoryQuantityButton) {
          const card = accessoryQuantityButton.closest('[data-accessory-card]');
          const value = card.querySelector('[data-accessory-quantity]');
          const input = card.querySelector('[data-accessory-input]');
          const next = Math.max(1, Number(value.textContent) + Number(accessoryQuantityButton.dataset.accessoryQuantityChange));
          value.textContent = String(next);
          input.dataset.quantity = String(next);
          this.updateTotals();
          return;
        }

        const accessoryVariantButton = event.target.closest('[data-accessory-variant]');
        if (accessoryVariantButton) {
          const card = accessoryVariantButton.closest('[data-accessory-card]');
          card.querySelectorAll('[data-accessory-variant]').forEach((button) => {
            button.classList.toggle('is-active', button === accessoryVariantButton);
          });
          const input = card.querySelector('[data-accessory-input]');
          input.value = accessoryVariantButton.dataset.variantId;
          input.dataset.price = accessoryVariantButton.dataset.variantPrice;
          const accessoryDescription = card.querySelector('[data-accessory-variant-title]');
          if (accessoryDescription && accessoryDescription.dataset.hasCustomDescription !== 'true') {
            accessoryDescription.textContent = accessoryVariantButton.dataset.variantTitle;
          }
          card.querySelector('[data-accessory-price]').textContent = `+${
            this.formatMoney(accessoryVariantButton.dataset.variantPrice)
          }`;
          this.updateTotals();
          return;
        }

        const thumbnail = event.target.closest('[data-gallery-index]');
        if (thumbnail && this.gallery) {
          this.gallery.slideTo(Number(thumbnail.dataset.galleryIndex));
          return;
        }

        const galleryMore = event.target.closest('[data-gallery-more]');
        if (galleryMore && this.gallery) {
          this.gallery.slideTo(Number(galleryMore.dataset.galleryStartIndex));
          return;
        }

        const navLink = event.target.closest('[data-scroll-selector]');
        if (navLink) {
          this.centerNavLink(navLink);
          const selector = navLink.dataset.scrollSelector;
          const destination = selector
            ? document.querySelector(selector)
            : null;
          if (destination)
            destination.scrollIntoView({behavior: 'smooth', block: 'start'});


          return;
        }

        if (event.target.closest('[data-scroll-configurator]')) {
          const destination = this.querySelector('.scribe-v2__configurator');
          if (destination)
            destination.scrollIntoView({behavior: 'smooth', block: 'start'});


        }
      }

      openPlansDialog(trigger) {
        if (!this.plansDialog) return;

        this.plansModalTrigger = trigger;
        if (!this.plansDialog.open)
          this.plansDialog.showModal();

        this.loadPlansDialogContent();
      }

      async loadPlansDialogContent() {
        if (!this.plansContent || this.plansContent.dataset.loaded === 'true' || this.plansLoadPromise) return;


        const loading = this.plansContent.querySelector('[data-plans-loading]');
        const error = this.plansContent.querySelector('[data-plans-error]');

        this.plansLoadPromise = (async () => {
          const response = await fetch(this.dataset.plansSectionUrl, {
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          if (! response.ok)
            throw new Error(`Unable to load plans section: ${
              response.status
            }`);


          const source = new DOMParser().parseFromString(await response.text(), 'text/html');
          const plansSection = source.querySelector('[data-dtc3-plans]');
          if (! plansSection)
            throw new Error('Plans section is unavailable');

          const plansWrapper = plansSection.closest('.shopify-section') || plansSection.parentElement;

          const stylesheetUrls = Array.from(plansWrapper.querySelectorAll('link[rel="stylesheet"][href]')).map((link) => new URL(link.getAttribute('href'), window.location.origin).href);
          const scriptUrls = Array.from(plansWrapper.querySelectorAll('script[src]')).map((script) => new URL(script.getAttribute('src'), window.location.origin).href);

          await Promise.all(stylesheetUrls.map((url) => this.loadPlansStylesheet(url)));
          this.plansContent.replaceChildren(document.importNode(plansSection, true));
          await Promise.all(scriptUrls.map((url) => this.loadPlansScript(url)));

          this.plansContent.dataset.loaded = 'true';
          this.plansContent.setAttribute('aria-busy', 'false');
          this.plansContent.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles: true}));
        })();

        try {
          await this.plansLoadPromise;
        } catch (loadError) {
          if (loading)
            loading.hidden = true;

          if (error)
            error.hidden = false;

          this.plansContent.setAttribute('aria-busy', 'false');
        } finally {
          this.plansLoadPromise = null;
        }
      }

      loadPlansStylesheet(url) {
        const existing = Array.from(document.querySelectorAll('link[rel="stylesheet"][href]')).find((link) => link.href === url);
        if (existing) return Promise.resolve();


        return new Promise((resolve, reject) => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = url;
          link.addEventListener('load', resolve, {once: true});
          link.addEventListener('error', reject, {once: true});
          document.head.appendChild(link);
        });
      }

      loadPlansScript(url) {
        const existing = Array.from(document.querySelectorAll('script[src]')).find((script) => script.src === url);
        if (existing) return Promise.resolve();


        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.addEventListener('load', resolve, {once: true});
          script.addEventListener('error', reject, {once: true});
          document.head.appendChild(script);
        });
      }

      centerNavLink(navLink) {
        const navLinks = navLink.closest('.scribe-v2__nav-links');
        if (! navLinks) return;


        navLinks.querySelectorAll('.scribe-v2__nav-link').forEach((link) => {
          link.classList.toggle('is-active', link === navLink);
        });
        const navRect = navLinks.getBoundingClientRect();
        const linkRect = navLink.getBoundingClientRect();
        const left = navLinks.scrollLeft + linkRect.left - navRect.left -(navRect.width - linkRect.width) / 2;

        navLinks.scrollTo({left, behavior: 'smooth'});
      }

      updateFloatingNav() {
        if (!this.nav || !this.navAnchor) return;


        const navHeight = this.nav.offsetHeight;
        const anchorTop = this.navAnchor.getBoundingClientRect().top + window.scrollY;
        const shouldFloat = window.scrollY >= anchorTop;

        this.style.setProperty('--scribe-nav-height', `${navHeight}px`);
        this.nav.classList.toggle('is-floating', shouldFloat);
        this.navAnchor.style.height = shouldFloat
          ? `${navHeight}px`
          : '';
      }

      changeNumberInput(input, change) {
        if (!input) return;


        const min = Number(input.min || 1);
        const max = input.max
          ? Number(input.max)
          : Infinity;
        const step = Number(input.step || 1);
        const next = Math.min(max, Math.max(min, Number(input.value || min) + change * step));
        input.value = String(next);
        input.dispatchEvent(new Event('change', {bubbles: true}));
      }

      initializeCountdowns() {
        this.querySelectorAll('.product__event-countdown-timer-value, .spring-promo-banner__timer').forEach((timer) => {
          if (!timer.dataset.end) return;

          const endTime = new Date(timer.dataset.end);
          if (Number.isNaN(endTime.getTime())) return;

          const updateTimer = () => {
            const difference = endTime.getTime() - Date.now();
            if (difference <= 0) {
              timer.textContent = '00:00:00';
              return;
            }

            const totalSeconds = Math.floor(difference / 1000);
            const days = Math.floor(totalSeconds / 86400);
            const hours = Math.floor((totalSeconds % 86400) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            const pad = (value) => String(value).padStart(2, '0');

            if (timer.classList.contains('spring-promo-banner__timer') && days > 0) {
              timer.textContent = `${days}${timer.dataset.dayLabel || 'D'} ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
              return;
            }

            timer.textContent = `${days > 0 ? `${pad(days)}:` : ''}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
          };

          updateTimer();
          this.countdownIntervals.push(window.setInterval(updateTimer, 1000));
        });
      }

      updateProduct() {
        const options = this.selectedOptions;
        const variant = this.findVariant(options);
        this.currentVariant = variant || null;

        if (this.variantInput) {
          this.variantInput.value = variant?.id || '';
          this.variantInput.disabled = ! variant;
        }

        if (this.submitButton) {
          this.submitButton.disabled = ! variant || ! variant.available;
        }

        if (variant) {
          if (this.mainPrice) {
            this.mainPrice.textContent = this.formatMoney(variant.price);
          }
          const nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', nextUrl);
          this.updateGalleryForVariant(variant);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: this.dataset.sectionId,
                variant
              }
            });
          }
        }

        this.updateChoicePrices(options);
        this.updateAvailability(options);
        this.updateTotals();
      }

      updateChoicePrices(options) {
        const baseOptions = [...options];
        baseOptions[2] = this.basePlanValue;
        const baseVariant = this.findVariant(baseOptions);

        this.querySelectorAll('[data-hardware-price]').forEach((price) => {
          const targetOptions = [...options];
          targetOptions[1] = price.dataset.optionValue;
          targetOptions[2] = this.basePlanValue;
          const targetVariant = this.findVariant(targetOptions);
          price.textContent = targetVariant
            ? this.formatMoney(targetVariant.price)
            : '';
        });

        this.querySelectorAll('[data-plan-price]').forEach((price) => {
          const targetOptions = [...options];
          targetOptions[2] = price.dataset.optionValue;
          const targetVariant = this.findVariant(targetOptions);
          if (! targetVariant || ! baseVariant) {
            price.textContent = '';
            return;
          }
          const difference = targetVariant.price - baseVariant.price;
          price.textContent = difference > 0
            ? `+${
            this.formatMoney(difference)
          }/yr` : 'Free';
        });
      }

      updateAvailability(options) {
        this.optionInputs.forEach((input) => {
          const targetOptions = [...options];
          targetOptions[Number(input.dataset.optionIndex)] = input.value;
          const targetVariant = this.findVariant(targetOptions);
          input.disabled = ! targetVariant || ! targetVariant.available;
        });
      }

      updateTotals() {
        if (!this.currentVariant) return;


        const mainQuantity = Math.max(1, Number(this.mainQuantity?.value || 1));
        let total = this.currentVariant.price * mainQuantity;

        this.querySelectorAll('[data-accessory-input]:checked').forEach((input) => {
          total += Number(input.dataset.price || 0) * Number(input.dataset.quantity || 1);
        });

        if (this.orderTotal) {
          this.orderTotal.textContent = this.formatMoney(total);
        }
      }

      initializeThumbnailImages() {
        this.querySelectorAll('[data-thumbnail-src]').forEach((thumbnail) => {
          const image = thumbnail.querySelector('.scribe-v2__thumbnail-image');
          const fallbackUrl = thumbnail.dataset.thumbnailSrc;
          if (! image || ! fallbackUrl) return;



          image.addEventListener('error', () => {
            image.removeAttribute('srcset');
            image.src = `${fallbackUrl}${
              fallbackUrl.includes('?')
                ? '&'
                : '?'
              }retry=1`;
          }, {once: true});
        });
      }

      initializeGallery() {
        let attempts = 0;
        const connect = () => {
          const swiperElement = this.querySelector('.scribe-v2__media-swiper');
          if (!swiperElement?.swiper) {
            attempts += 1;
            if (attempts < 40)
              window.setTimeout(connect, 100);


            return;
          }

          this.gallery = swiperElement.swiper;
          this.gallery.on('slideChange', () => this.updateActiveThumbnail(this.gallery.activeIndex));
          this.updateGalleryForVariant(this.currentVariant);
        };
        connect();
      }

      updateGalleryForVariant(variant) {
        const mediaId = variant?.featured_media?.id;
        if (! mediaId) return;


        const slides = Array.from(this.querySelectorAll('.scribe-v2__media-slide'));
        const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (index >= 0 && this.gallery)
          this.gallery.slideTo(index, 0);


        if (index >= 0)
          this.updateActiveThumbnail(index);


      }

      updateActiveThumbnail(index) {
        const thumbnails = Array.from(this.querySelectorAll('[data-gallery-index]'));
        thumbnails.forEach((thumbnail) => {
          const thumbnailIndex = Number(thumbnail.dataset.galleryIndex);
          const active = thumbnailIndex === index;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-current', String(active));
          if (active)
            thumbnail.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});


        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scribe-v2-a-plus-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scribe-a-plus-hero')) {
      customElements.define('scribe-a-plus-hero', class extends HTMLElement {
        connectedCallback() {
          this.copy = this.querySelector('[data-hero-copy]');
          this.benefits = this.querySelector('[data-hero-benefits]');
          this.desktopVideo = this.querySelector('video.scribe-a-plus-hero__media--desktop');
          this.mobileVideo = this.querySelector('video.scribe-a-plus-hero__media--mobile');
          this.mobileViewport = window.matchMedia('(max-width: 1024px)');
          this.playTrigger = Number(this.dataset.playTrigger || 0.45);
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.frame = null;
          this.videoStarted = false;
          this.video = null;
          this.syncActiveVideo();
          this.update = this.update.bind(this);
          this.requestUpdate = this.requestUpdate.bind(this);
          window.addEventListener('scroll', this.requestUpdate, {passive: true});
          window.addEventListener('resize', this.requestUpdate, {passive: true});
          this.initBenefitsReveal();
          this.requestUpdate();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.requestUpdate);
          window.removeEventListener('resize', this.requestUpdate);
          if (this.benefitsObserver) 
            this.benefitsObserver.disconnect();
          


          if (this.frame) 
            cancelAnimationFrame(this.frame);
          


        }

        syncActiveVideo() {
          const useMobileVideo = this.mobileViewport.matches && this.classList.contains('has-mobile-media');
          const nextVideo = useMobileVideo ? this.mobileVideo : this.desktopVideo;
          if (nextVideo === this.video) return;

          if (this.video) {
            this.video.pause();
            this.video.currentTime = 0;
          }

          this.video = nextVideo;
          this.videoStarted = false;
        }

        initBenefitsReveal() {
          if (!this.benefits) return;
          


          this.classList.add('is-benefits-ready');
          if (this.reducedMotion.matches || !('IntersectionObserver' in window)) {
            this.benefits.classList.add('is-visible');
            return;
          }

          this.benefitsObserver = new IntersectionObserver((entries, observer) => {
            if (!entries[0].isIntersecting) return;
            


            this.benefits.classList.add('is-visible');
            observer.disconnect();
          }, {threshold: 0.2});
          this.benefitsObserver.observe(this.benefits);
        }

        requestUpdate() {
          if (this.frame) return;
          


          this.frame = requestAnimationFrame(this.update);
        }

        update() {
            this.frame = null;
            this.syncActiveVideo();
            const productNav = document.querySelector('.scribe-v2-product-nav__nav');
            const viewportOffset = productNav ? Math.max(productNav.getBoundingClientRect().height, 0) : 0;
            this.style.setProperty('--hero-viewport-offset', `${viewportOffset}px`);
            if (this.reducedMotion.matches) {
              this.style.setProperty('--hero-progress', '0');
              this.style.setProperty('--hero-copy-opacity', '1');
              if (this.video && this.videoStarted) {
                this.videoStarted = false;
                this.video.pause();
                this.video.currentTime = 0;
              }
              return;
            }

            const rect = this.getBoundingClientRect();
            const distance = Math.max(this.offsetHeight - window.innerHeight, 1);
            const progress = Math.min(Math.max(- rect.top / distance, 0), 1);
            const copyFade = Math.min(Math.max((progress - 0.04) / 0.22, 0), 1);

            this.style.setProperty('--hero-progress', progress.toFixed(4));
            this.style.setProperty('--hero-copy-opacity', (1 - copyFade).toFixed(4));

            if (!this.video) return;
            


            const shouldPlay = copyFade >= 1 && progress >= this.playTrigger && rect.bottom > 0 && rect.top<window.innerHeight;
          if (shouldPlay && !this.videoStarted) {
            this.videoStarted = true;
            this.video.play().catch(() => {
              this.videoStarted = false;
            }
          );
        } else if(! shouldPlay && this.videoStarted) {
          this.videoStarted = false;
          this.video.pause();
          this.video.currentTime = 0;
        }
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scribe-v2-personas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scribe-personas')) {
    customElements.define('scribe-personas', class ScribePersonas extends HTMLElement {
      connectedCallback() {
        if (this.dataset.personasInitialized === 'true') return;

        this.dataset.personasInitialized = 'true';
        this.cards = Array.from(this.querySelectorAll('[data-persona-card]'));
        this.slides = this.cards.map((card) => card.closest('.swiper-slide')).filter(Boolean);
        this.slideAnimations = new Map();
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.handleClickBound = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClickBound);
        this.cards.forEach((card) => this.syncCardMedia(card, false));

        if (window.matchMedia('(max-width: 767px)').matches && this.cards[0]) {
          this.setExpanded(this.cards[0], true);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClickBound);
        this.slideAnimations.forEach((animation) => animation.cancel());
        this.slideAnimations.clear();
      }

      handleClick(event) {
        if (event.target.closest('[data-persona-link]')) return;

        const card = event.target.closest('[data-persona-card]');
        if (!card || !this.contains(card)) return;

        this.setExpanded(card, !card.classList.contains('is-expanded'));
      }

      setExpanded(card, isExpanded) {
        const toggle = card.querySelector('[data-persona-toggle]');
        const detail = card.querySelector('[data-persona-detail]');
        const collapsedContent = card.querySelector('[data-persona-collapsed-content]');
        const collapsedMedia = card.querySelector('[data-persona-collapsed-media]');
        const expandedMedia = card.querySelector('[data-persona-expanded-media]');
        const slide = card.closest('.swiper-slide');
        const beforePositions = this.captureSlidePositions();

        this.slideAnimations.forEach((animation) => animation.cancel());
        this.slideAnimations.clear();

        card.classList.toggle('is-expanded', isExpanded);
        slide?.classList.toggle('is-expanded', isExpanded);
        toggle?.setAttribute('aria-expanded', String(isExpanded));
        toggle?.setAttribute('aria-label', `${isExpanded ? 'Collapse' : 'Expand'} ${card.querySelector('.scribe-personas__title')?.textContent.trim() || 'persona'}`);
        detail?.setAttribute('aria-hidden', String(!isExpanded));
        detail?.toggleAttribute('inert', !isExpanded);
        collapsedContent?.setAttribute('aria-hidden', String(isExpanded));
        collapsedMedia?.setAttribute('aria-hidden', String(isExpanded));
        expandedMedia?.setAttribute('aria-hidden', String(!isExpanded));
        this.syncCardMedia(card, isExpanded);
        this.updateSwiper();
        if (isExpanded) {
          this.centerSlide(slide);
        } else {
          this.restoreSwiperPosition();
        }
        this.animateSlidePositions(beforePositions);
      }

      syncCardMedia(card, isExpanded) {
        const activeLayer = card.querySelector(isExpanded ? '[data-persona-expanded-media]' : '[data-persona-collapsed-media]');

        card.querySelectorAll('video').forEach((video) => {
          const shouldPlay = !this.prefersReducedMotion && activeLayer?.contains(video);

          if (!shouldPlay) {
            video.pause();
            return;
          }

          video.muted = true;
          video.playsInline = true;
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      }

      captureSlidePositions() {
        return new Map(this.slides.map((slide) => [slide, slide.getBoundingClientRect().left]));
      }

      animateSlidePositions(beforePositions) {
        if (this.prefersReducedMotion) return;

        this.slides.forEach((slide) => {
          const previousLeft = beforePositions.get(slide);
          const currentLeft = slide.getBoundingClientRect().left;
          const deltaX = previousLeft - currentLeft;

          if (!Number.isFinite(deltaX) || Math.abs(deltaX) < 0.5) return;

          const animation = slide.animate(
            [
              { transform: `translate3d(${deltaX}px, 0, 0)` },
              { transform: 'translate3d(0, 0, 0)' },
            ],
            {
              duration: 300,
              easing: 'cubic-bezier(0.2, 0, 0, 1)',
            }
          );

          this.slideAnimations.set(slide, animation);
          animation.finished
            .catch(() => {})
            .finally(() => {
              if (this.slideAnimations.get(slide) === animation) {
                this.slideAnimations.delete(slide);
              }
            });
        });
      }

      centerSlide(slide) {
        const swiper = this.getSwiper();
        if (!swiper || !slide) return;

        const slideIndex = Array.from(swiper.slides).indexOf(slide);
        if (slideIndex < 0) return;

        swiper.params.centeredSlides = slideIndex > 0;
        swiper.update();
        swiper.slideTo(slideIndex, 0, false);
      }

      restoreSwiperPosition() {
        const swiper = this.getSwiper();
        if (!swiper) return;

        swiper.params.centeredSlides = false;
        swiper.update();
        swiper.slideTo(0, 0, false);
      }

      getSwiper() {
        const swiperElement = this.querySelector('.scribe-personas__swiper');
        return swiperElement?.flowticaSwiper || swiperElement?.swiper;
      }

      updateSwiper() {
        const swiper = this.getSwiper();
        if (!swiper) return;

        swiper.update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scribe-v2-product-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scribe-v2-product-nav')) {
    customElements.define('scribe-v2-product-nav', class ScribeV2ProductNav extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('[data-product-nav]');
        this.anchor = this.querySelector('[data-nav-anchor]');
        if (!this.nav || !this.anchor) return;

        document.documentElement.classList.add('scribe-v2-page-nav-enabled');
        document
          .querySelector('.section-header')
          ?.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

        this.handleClickBound = this.handleClick.bind(this);
        this.updateFloatingBound = this.updateFloating.bind(this);
        this.handleResizeBound = this.handleResize.bind(this);
        this.resizeReleaseTimer = null;
        this.isResizing = false;
        this.addEventListener('click', this.handleClickBound);
        window.addEventListener('scroll', this.updateFloatingBound, { passive: true });
        window.addEventListener('resize', this.handleResizeBound);
        this.updateFloating();
      }

      disconnectedCallback() {
        document.documentElement.classList.remove('scribe-v2-page-nav-enabled');
        this.removeEventListener('click', this.handleClickBound);
        window.removeEventListener('scroll', this.updateFloatingBound);
        window.removeEventListener('resize', this.handleResizeBound);
        window.clearTimeout(this.resizeReleaseTimer);
      }

      handleClick(event) {
        const navLink = event.target.closest('[data-scroll-selector]');
        if (navLink) {
          let destination = null;
          try {
            destination = document.querySelector(navLink.dataset.scrollSelector);
          } catch {
            destination = null;
          }
          if (destination) this.scrollToDestination(destination);
          this.querySelectorAll('.scribe-v2-product-nav__link').forEach((link) => {
            link.classList.toggle('is-active', link === navLink);
          });
          return;
        }

        const cta = event.target.closest('[data-scroll-cta-selector]');
        if (cta) {
          let destination = null;
          try {
            destination = document.querySelector(cta.dataset.scrollCtaSelector);
          } catch {
            destination = null;
          }
          if (destination) this.scrollToDestination(destination);
        }
      }

      scrollToDestination(destination) {
        if (!this.classList.contains('scribe-v2-product-nav--verso')) {
          destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const top = destination.getBoundingClientRect().top + window.scrollY - this.nav.offsetHeight;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      updateFloating() {
        if (this.isResizing && this.nav.classList.contains('is-floating')) return;

        const shouldFloat = this.anchor.getBoundingClientRect().top <= 0;
        this.nav.classList.toggle('is-floating', shouldFloat);
        this.anchor.style.height = shouldFloat ? `${this.nav.offsetHeight}px` : '';
      }

      handleResize() {
        const wasFloating = this.nav.classList.contains('is-floating');
        this.isResizing = true;
        window.clearTimeout(this.resizeReleaseTimer);

        if (wasFloating) {
          this.anchor.style.height = `${this.nav.offsetHeight}px`;
        } else {
          this.updateFloating();
        }

        this.resizeReleaseTimer = window.setTimeout(() => {
          this.isResizing = false;
        }, 250);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scribe-v2-roi-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scribe-roi-calculator')) {
    customElements.define('scribe-roi-calculator', class ScribeRoiCalculator extends HTMLElement {
      connectedCallback() {
        this.hoursInput = this.querySelector('[data-hours-input]');
        this.rateInput = this.querySelector('[data-rate-input]');
        this.hoursOutput = this.querySelector('[data-hours-output]');
        this.rateOutput = this.querySelector('[data-rate-output]');
        this.annualHoursOutput = this.querySelector('[data-annual-hours]');
        this.annualValueOutput = this.querySelector('[data-annual-value]');
        this.paybackOutput = this.querySelector('[data-payback]');
        this.detailsToggle = this.querySelector('[data-details-toggle]');
        this.detailsPanel = this.querySelector('[data-details-panel]');

        if (this.detailsToggle && this.detailsPanel) {
          this.toggleDetailsBound = this.toggleDetails.bind(this);
          this.detailsTransitionBound = this.onDetailsTransitionEnd.bind(this);
          this.detailsToggle.addEventListener('click', this.toggleDetailsBound);
          this.detailsPanel.addEventListener('transitionend', this.detailsTransitionBound);

          if (window.matchMedia('(max-width: 767px)').matches) {
            this.detailsToggle.setAttribute('aria-expanded', 'true');
            this.detailsPanel.setAttribute('aria-hidden', 'false');
            this.detailsPanel.removeAttribute('inert');
            this.detailsPanel.style.height = 'auto';
            this.detailsToggle.closest('.scribe-roi__details')?.classList.add('is-open');
          }
        }

        if (!this.hoursInput || !this.rateInput) return;

        this.updateBound = this.update.bind(this);
        this.hoursInput.addEventListener('input', this.updateBound);
        this.rateInput.addEventListener('input', this.updateBound);
        this.update();
      }

      disconnectedCallback() {
        this.hoursInput?.removeEventListener('input', this.updateBound);
        this.rateInput?.removeEventListener('input', this.updateBound);
        this.detailsToggle?.removeEventListener('click', this.toggleDetailsBound);
        this.detailsPanel?.removeEventListener('transitionend', this.detailsTransitionBound);
        cancelAnimationFrame(this.detailsAnimationFrame);
      }

      toggleDetails() {
        const isOpen = this.detailsToggle.getAttribute('aria-expanded') === 'true';
        const details = this.detailsToggle.closest('.scribe-roi__details');
        const currentHeight = this.detailsPanel.getBoundingClientRect().height;

        cancelAnimationFrame(this.detailsAnimationFrame);
        this.detailsPanel.style.height = `${currentHeight}px`;
        this.detailsToggle.setAttribute('aria-expanded', String(!isOpen));
        this.detailsPanel.setAttribute('aria-hidden', String(isOpen));
        this.detailsPanel.toggleAttribute('inert', isOpen);
        details?.classList.toggle('is-open', !isOpen);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.detailsPanel.style.height = isOpen ? '0px' : 'auto';
          return;
        }

        const targetHeight = isOpen ? 0 : this.detailsPanel.scrollHeight;
        this.detailsAnimationFrame = requestAnimationFrame(() => {
          this.detailsPanel.style.height = `${targetHeight}px`;
        });
      }

      onDetailsTransitionEnd(event) {
        if (event.propertyName !== 'height') return;
        if (this.detailsToggle.getAttribute('aria-expanded') === 'true') {
          this.detailsPanel.style.height = 'auto';
        }
      }

      formatCurrency(cents, fractionDigits = 2) {
        const currency = this.dataset.currency || 'USD';
        const locale = this.dataset.locale || 'en-US';
        const amount = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        }).format(cents / 100);
        return `${amount} ${currency}`;
      }

      formatPayback(days) {
        if (!Number.isFinite(days)) return '—';
        if (days <= 1) return 'under a day';
        if (days < 14) return `~${Math.round(days)} days`;
        if (days < 60) return `~${Math.round(days / 7)} weeks`;
        return `~${Math.round((days / 30.44) * 10) / 10} months`;
      }

      update() {
        const hours = Number(this.hoursInput.value);
        const rate = Number(this.rateInput.value);
        const productPrice = Number(this.dataset.productPriceCents || 15900) / 100;
        const weeklyValue = hours * rate;
        const monthlyValue = weeklyValue * 4.345;
        const annualHours = Math.round(hours * 52);
        const annualValueCents = Math.round(annualHours * rate * 100);
        const paybackDays = monthlyValue > 0 ? productPrice / (monthlyValue / 30.44) : Number.POSITIVE_INFINITY;

        this.updateSliderProgress(this.hoursInput);
        this.updateSliderProgress(this.rateInput);

        this.hoursOutput.textContent = `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;
        this.rateOutput.textContent = `${this.formatCurrency(rate * 100, 0)}/hr`;
        this.annualHoursOutput.textContent = annualHours.toLocaleString();
        this.annualValueOutput.textContent = this.formatCurrency(annualValueCents, 0);
        this.paybackOutput.textContent = this.formatPayback(paybackDays);
      }

      updateSliderProgress(input) {
        const min = Number(input.min);
        const max = Number(input.max);
        const value = Number(input.value);
        const progress = max > min ? ((value - min) / (max - min)) * 100 : 0;
        input.style.setProperty('--slider-progress', `${progress}%`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
